import { createAction, props } from "@ngrx/store";

import {
  BulkFeatureFlagUpdate,
  ProductFeatureSummary,
} from "./owner-feature-flags.models";

export const loadAllProductsFeatures = createAction(
  "[Owner Feature Flags] Load All Products Features"
);

export const loadAllProductsFeaturesSuccess = createAction(
  "[Owner Feature Flags] Load All Products Features Success",
  props<{ summaries: ProductFeatureSummary[] }>()
);

export const loadAllProductsFeaturesFailure = createAction(
  "[Owner Feature Flags] Load All Products Features Failure",
  props<{ error: string }>()
);

export const bulkSetProductFeatures = createAction(
  "[Owner Feature Flags] Bulk Set Product Features",
  props<{ update: BulkFeatureFlagUpdate }>()
);

export const bulkSetProductFeaturesSuccess = createAction(
  "[Owner Feature Flags] Bulk Set Product Features Success",
  props<{ update: BulkFeatureFlagUpdate }>()
);

export const bulkSetProductFeaturesFailure = createAction(
  "[Owner Feature Flags] Bulk Set Product Features Failure",
  props<{ error: string }>()
);
